import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import styles from './shell.module.css';
export function ContextCrumbs({ lineage, onNavigate }) {
    return (_jsx("nav", { "aria-label": "Data lineage", className: styles.crumbs, children: lineage.map((item, i) => {
            const isLast = i === lineage.length - 1;
            return (_jsxs(Fragment, { children: [i > 0 ? (_jsx("span", { className: styles.crumbSep, "aria-hidden": "true", children: "\u203A" })) : null, isLast || !item.href ? (_jsx("span", { className: styles.crumbHere, "aria-current": isLast ? 'page' : undefined, children: item.label })) : (_jsx("a", { className: styles.crumb, href: item.href, onClick: (e) => {
                            if (onNavigate && item.href) {
                                e.preventDefault();
                                onNavigate(item.href);
                            }
                        }, children: item.label }))] }, `${item.label}-${i}`));
        }) }));
}
//# sourceMappingURL=ContextCrumbs.js.map